import { render, staticRenderFns } from "./ButtonTab.vue?vue&type=template&id=34f4d2ce"
import script from "./ButtonTab.vue?vue&type=script&lang=js"
export * from "./ButtonTab.vue?vue&type=script&lang=js"
import style0 from "./ButtonTab.vue?vue&type=style&index=0&id=34f4d2ce&prod&lang=scss&module=true"
import style1 from "./ButtonTab.vue?vue&type=style&index=1&id=34f4d2ce&prod&lang=scss&scope=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports